import { useUserContext } from '@contexts/UserContext'
import { PremiumState } from '@libs/graphql/types'

export function useGetUserPremiumStatus(): PremiumState {
  const { user } = useUserContext()

  return user?.premium_state ?? PremiumState.NONE
}
